export const API_ENDPOINTS = {
  AUTH: {
    TOKEN: '/api/user/token',
    REFRESH_TOKEN: '/api/user/refresh-token',
    LOGOUT: '/api/user/logout',
  },
  USER: {
    PROFILE: '/api/user/profile',
    SETTINGS: '/api/user/settings',
  },
  // Add more endpoint categories as needed
} as const;

// Type for API endpoints
export type ApiEndpoint = typeof API_ENDPOINTS;

// Helper function to get full endpoint path
export const getEndpoint = (path: string): string => {
  return path;
}; 